import { encartEditoMock, listeAccordeonMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listeAccordeonMock('franchiseProjectSteps'), encartEditoMock];

export const franchiseEtapesProjetMock: SlugPage = {
  ...pageBase({
    title: 'Espace Franchise - Etapes Projet',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
